<template>
  <el-card shadow="never">
    <div slot="header" class="card-header">
      <span>分享奖励配置</span>
    </div>

    <el-form ref="formRef" :model="form" :rules="rules" label-width="180px" class="config-form">
      <el-form-item label="分享奖励总开关" prop="enabled">
        <el-switch v-model="form.enabled" />
      </el-form-item>

      <el-divider content-position="left">商品分享访问奖励</el-divider>
      <el-form-item label="启用商品访问奖励" prop="productVisitRewardEnabled">
        <el-switch v-model="form.productVisitRewardEnabled" />
      </el-form-item>
      <el-form-item label="访问奖励积分" prop="productVisitRewardPoints">
        <el-input-number v-model="form.productVisitRewardPoints" :min="0" :max="1000" />
        <div class="tip">用户通过分享链接首次打开商品详情时，给分享者发放积分。</div>
      </el-form-item>

      <el-divider content-position="left">团购支付奖励</el-divider>
      <el-form-item label="启用团购支付奖励" prop="groupPayRewardEnabled">
        <el-switch v-model="form.groupPayRewardEnabled" />
      </el-form-item>
      <el-form-item label="支付奖励积分" prop="groupPayRewardPoints">
        <el-input-number v-model="form.groupPayRewardPoints" :min="0" :max="5000" />
        <div class="tip">被邀请用户通过团购分享进入并完成支付后，给分享者发放积分。</div>
      </el-form-item>

      <el-divider content-position="left">风控限制</el-divider>
      <el-form-item label="每日奖励上限" prop="dailyRewardLimit">
        <el-input-number v-model="form.dailyRewardLimit" :min="0" :max="1000" />
        <div class="tip">同一分享者每天最多获得多少次分享奖励，填 0 表示不限制。</div>
      </el-form-item>
      <el-form-item label="归因有效时长(小时)" prop="expireHours">
        <el-input-number v-model="form.expireHours" :min="1" :max="720" />
        <div class="tip">分享访问记录在该时长内有效，过期后不再触发团购支付奖励。</div>
      </el-form-item>
    </el-form>

    <div class="footer-actions">
      <el-button :loading="loading" @click="loadData">重置</el-button>
      <el-button type="primary" :loading="saving" @click="submit">保存配置</el-button>
    </div>
  </el-card>
</template>

<script>
import { getShareRewardConfig, saveShareRewardConfig } from '../../api/admin'

const createForm = () => ({
  enabled: true,
  productVisitRewardEnabled: true,
  productVisitRewardPoints: 2,
  groupPayRewardEnabled: true,
  groupPayRewardPoints: 10,
  dailyRewardLimit: 20,
  expireHours: 72
})

export default {
  data() {
    return {
      loading: false,
      saving: false,
      form: createForm(),
      rules: {
        productVisitRewardPoints: [{ required: true, message: '请输入访问奖励积分', trigger: 'change' }],
        groupPayRewardPoints: [{ required: true, message: '请输入团购支付奖励积分', trigger: 'change' }],
        dailyRewardLimit: [{ required: true, message: '请输入每日奖励上限', trigger: 'change' }],
        expireHours: [{ required: true, message: '请输入归因有效时长', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const data = await getShareRewardConfig()
        this.form = { ...createForm(), ...data }
      } catch (error) {
        this.$message.error(error?.message || '分享奖励配置加载失败')
      } finally {
        this.loading = false
      }
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          await saveShareRewardConfig(this.form)
          this.$message.success('分享奖励配置已保存')
        } catch (error) {
          this.$message.error(error?.message || '分享奖励配置保存失败')
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style scoped>
.card-header { font-weight: 600; }
.config-form { max-width: 760px; }
.tip { margin-top: 8px; color: #909399; line-height: 1.7; font-size: 13px; }
.footer-actions { margin-top: 24px; }
</style>
